export const config = {
  apiUrl: import.meta.env.VITE_API_URL ?? '',
  hubUrl: import.meta.env.VITE_HUB_URL ?? '/hubs/game',
};
